import React, { useState, useEffect } from "react";

import {
  Col,
  Row,
  Progress,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown,
  Spinner,
  Alert,
} from "reactstrap";
import Widget from "../../components/Widget/Widget.js";

import "eva-icons/style/eva-icons.css";

import ApexCharts from "react-apexcharts";

import jwt_decode from "jwt-decode";
import swal from "sweetalert";

import axios from "axios";
import {
  API_TIMEOUT,
  PROGRESS_BANTUAN_API,
  PROGRESS_DINAS_API,
  KECAMATAN_BANTUAN_TAHUN,
  AKUMULASI_DESIL_LIMATAHUN,
  LIMA_TAHUN_TERAKHIR,
  ADMIN_TOKEN,
} from "../../utils/index.js";

import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import s from "./Dashboard.module.scss";

import Map from "../../components/am4chartMap/am4chartMap.js";

import { logoutUser } from "../../actions/auth.js";
import { useDispatch } from "react-redux";

function getAxiosErrorMessage(error) {
  const d = error?.response?.data;
  if (d && typeof d === "object" && d.message) return String(d.message);
  if (typeof d === "string" && d.length < 500) return d;
  return error?.message || "Gagal memuat data";
}

const emptySection = { loading: false, error: null };

export default function Dashboard(props) {
  const [currentUser, setCurrentUser] = useState(null);

  const currentYear = new Date().getFullYear();
  const [simpleDropdownValue, setSimpleDropdownValue] = useState(String(currentYear));

  const [progresDinas, setProgresDinas] = useState([]);
  const [progresKecamatan, setProgresKecamatan] = useState([]);

  const [expire, setExpire] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const dispatch = useDispatch();
  const doLogout = () => {
    dispatch(logoutUser());
  };
  const refreshToken = async () => {
    try {
      const response = await axios.get(ADMIN_TOKEN, {
        credentials: "include",
      });
      const decoded = jwt_decode(response.data.accessToken);

      setAccessToken(response.data.accessToken);

      setExpire(decoded.exp);
    } catch (error) {
      doLogout();
    }
  };

  const [listAkumulasiDesil, setListAkumulasiDesil] = useState([]);

  const [limaTahun, setLimaTahun] = useState({ label: [], data: [] });

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(ADMIN_TOKEN);
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;

        const decoded = jwt_decode(response.data.accessToken);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const formatRupiahForChart = (n) =>
    new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(n);

  const DESIL_KETERANGAN = {
    "Desil 1": "Sangat Miskin",
    "Desil 2": "Miskin",
    "Desil 3": "Rentan Miskin",
    "Desil 4": "Hampir Rentan",
    "Desil 5": "Menengah Bawah",
    "Diatas Desil 5": "Menengah Atas",
  };

  const totalDanaAkumulasi5Tahun = listAkumulasiDesil.reduce(
    (s, d) => s + (Number(d.total_uang) || 0),
    0
  );

  const highcharts = {
    variableRadiusPie: {
      chart: {
        type: "variablepie",
      },
      title: {
        text: "Akumulasi Nilai Bantuan 5 Tahun Terakhir per Desil",
      },
      subtitle: {
        text: `Total Dana Bantuan: ${formatRupiahForChart(totalDanaAkumulasi5Tahun)}`,
        style: { fontSize: "14px", color: "#6b7280" },
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        headerFormat: "",
        pointFormat:
          '<span style="color:{point.color}">\u25CF</span> <b>{point.name}</b><br/>' +
          "Total Dana: <b>{point.formatted}</b><br/>",
      },
      colors: [
        "#16365f",
        "#41D5E2",
        "#FFC405",
        "#43BC13",
        "#FF5668",
        "#C7D0D9",
      ],
      series: [
        {
          minPointSize: 10,
          innerSize: "20%",
          zMin: 0,
          name: "desil",
          data: listAkumulasiDesil.map((d) => {
            const keterangan = DESIL_KETERANGAN[d.name] || "";
            const label = keterangan ? `${d.name} — ${keterangan}` : d.name;
            return {
              name: label,
              y: d.total_uang,
              z: 1,
              formatted: formatRupiahForChart(d.total_uang),
            };
          }),
        },
      ],
    },
  };

  const fetchAkumulasiDesil = () => {
    setSectionPie({ loading: true, error: null });
    axios({
      method: "get",
      url: AKUMULASI_DESIL_LIMATAHUN,
      timeout: API_TIMEOUT,
      credentials: "include",
    })
      .then((response) => {
        if (response.status !== 200) return;
        const data = response.data?.data ?? [];
        setListAkumulasiDesil(data);
        setSectionPie({ loading: false, error: null });
      })
      .catch((error) => {
        console.error("fetchAkumulasiDesil:", error?.message || error);
        setListAkumulasiDesil([]);
        setSectionPie({
          loading: false,
          error: getAxiosErrorMessage(error),
        });
      });
  };

  const limaTahunTerakhir = () => {
    const bearer = accessToken || localStorage.getItem("token") || "";
    setSectionLimaTahun({ loading: true, error: null });
    axios({
      method: "get",
      url: LIMA_TAHUN_TERAKHIR,
      timeout: API_TIMEOUT,
      headers: bearer ? { Authorization: `Bearer ${bearer}` } : {},
    })
      .then((response) => {
        if (response.status !== 200) {
          setSectionLimaTahun({
            loading: false,
            error: "Respons tidak valid",
          });
          return;
        }
        const data = response.data.data || [];

        const label = data.map((item) => String(item.tahun));

        const totalDesil12 = data.map((item) =>
          Number(item.total_desil12) || 0
        );

        const totalPenerima = data.map((item) =>
          Number(item.total_penerima) || 0
        );

        const dataKu = [
          {
            name: "Desil 1 + 2",
            data: totalDesil12,
          },
          {
            name: "Total Penerima",
            data: totalPenerima,
          },
        ];
        setLimaTahun({
          label: label,
          data: dataKu,
        });
        setSectionLimaTahun({ loading: false, error: null });
      })
      .catch((error) => {
        console.error("limaTahunTerakhir:", error?.message || error);
        setLimaTahun({
          label: [],
          data: [
            { name: "Desil 1 + 2", data: [] },
            { name: "Total Penerima", data: [] },
          ],
        });
        setSectionLimaTahun({
          loading: false,
          error: getAxiosErrorMessage(error),
        });
      });
  };

  const [chartBantuanDesil, setChartBantuanDesil] = useState({
    labels: [],
    totalPenerima: [],
    desil1: [],
    desil2: [],
    totalUang: [],
  });
  const [sectionChart, setSectionChart] = useState(emptySection);
  const [sectionLimaTahun, setSectionLimaTahun] = useState(emptySection);
  const [sectionPie, setSectionPie] = useState(emptySection);
  const [sectionDinas, setSectionDinas] = useState(emptySection);
  const [sectionKecamatan, setSectionKecamatan] = useState(emptySection);

  let satMin = [];

  const changeSelectDropdownSimple = (e) => {
    const select = e.currentTarget.textContent.trim();
    setSimpleDropdownValue(select);
  };

  const desil1Plus2 = chartBantuanDesil.desil1.map(
    (d1, i) => d1 + (chartBantuanDesil.desil2[i] || 0)
  );

  const xAxisLabels = chartBantuanDesil.labels.map((_, i) => String(i + 1));
  const bantuanLabels = chartBantuanDesil.labels;

  const totalUangArr = chartBantuanDesil.totalUang || [];
  const summaryRekapan = {
    jumlahBantuan: chartBantuanDesil.labels.length,
    totalDana: totalUangArr.reduce((s, v) => s + (Number(v) || 0), 0),
    totalPenerima: chartBantuanDesil.totalPenerima.reduce(
      (s, v) => s + (Number(v) || 0),
      0
    ),
    totalDesil12: desil1Plus2.reduce((s, v) => s + (Number(v) || 0), 0),
  };
  summaryRekapan.persentaseDesil12 =
    summaryRekapan.totalPenerima > 0
      ? (
          (summaryRekapan.totalDesil12 / summaryRekapan.totalPenerima) *
          100
        ).toFixed(1)
      : "0";

  const formatRupiah = (n) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(n);
  };

  const apexCharts = {
    lineColumn: {
      series: [
        {
          name: "Total Penerima",
          type: "column",
          data: chartBantuanDesil.totalPenerima,
        },
        {
          name: "Desil 1 + Desil 2",
          type: "line",
          data: desil1Plus2,
        },
      ],
      options: {
        colors: ["#C7D0D9", "#FF5668"],
        chart: {
          height: 350,
          type: "line",
          toolbar: { show: false },
        },
        stroke: {
          curve: "straight",
          width: [0, 1],
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
          style: { fontSize: "10px", fontWeight: 500 },
          background: { borderWidth: 0 },
        },
        xaxis: {
          type: "category",
          categories: xAxisLabels,
          labels: {
            style: { colors: "#6B859E" },
          },
        },
        yaxis: {
          title: {
            text: "Jumlah",
            style: { fontSize: "12px", fontWeight: 400, color: "#6B859E" },
          },
          labels: { style: { colors: ["#6B859E"] } },
        },
        tooltip: {
          custom: ({ series, seriesIndex, dataPointIndex }) => {
            const bantuanName = bantuanLabels[dataPointIndex] || "";
            const totalPenerima = series[0]?.[dataPointIndex] ?? 0;
            const desil12 = series[1]?.[dataPointIndex] ?? 0;
            const totalNum = Number(totalPenerima) || 0;
            const desilNum = Number(desil12) || 0;
            const persen =
              totalNum > 0
                ? ((desilNum / totalNum) * 100).toFixed(1) + "%"
                : "-";
            return (
              '<div class="apexcharts-tooltip-box" style="padding: 10px 14px;">' +
              '<div style="font-weight: 600; margin-bottom: 6px; color: #333;">' +
              (bantuanName || "Bantuan") +
              "</div>" +
              '<div style="font-size: 12px;">Total Penerima: <strong>' +
              totalPenerima +
              "</strong></div>" +
              '<div style="font-size: 12px;">Desil 1 + Desil 2: <strong>' +
              desil12 +
              "</strong></div>" +
              '<div style="font-size: 12px;">Persentase Desil 1+2: <strong>' +
              persen +
              "</strong></div>" +
              "</div>"
            );
          },
        },
        fill: { type: "solid", opacity: 1 },
      },
    },
    lineArea: {
      series: limaTahun.data,
      options: {
        chart: {
          type: "area",
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        xaxis: {
          type: "category",
          categories: limaTahun.label,
          labels: {
            style: {
              colors: "#6B859E",
              opacity: 0.7,
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: ["#6B859E"],
              opacity: 0.7,
            },
          },
        },
        tooltip: {
          x: {
            show: false,
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 1,
            stops: [40, 90, 100],
          },
        },
        colors: ["#4D53E0", "#41D5E2"],
        legend: {
          show: true,
          horizontalAlign: "center",
        },
      },
    },
  };

  useEffect(() => {
    if (!currentUser) {
      const currentUser = JSON.parse(localStorage.getItem("user"));
      setCurrentUser(currentUser);
    }

  //  refreshToken();

    // getDataMiskinKecamatan();
    // getDataMiskinKeluargaKecamatan();
    // getProgresDinas('2023');
    // pekerjaanPenduduk();
    // limaTahunTerakhir();
  }, []);

  useEffect(() => {
      if (!simpleDropdownValue) return;
      fetchChartBantuanDesil(simpleDropdownValue);
      fetchProgresDinas(simpleDropdownValue);
      fetchProgresKecamatan(simpleDropdownValue);
      fetchAkumulasiDesil();
      limaTahunTerakhir();
    }, [accessToken, simpleDropdownValue]);

  const listTahun = Array.from(
    { length: currentYear - 2018 + 1 },
    (_, i) => ({ tahun: 2018 + i })
  );

  const fetchChartBantuanDesil = (tahun) => {
    if (!tahun) return Promise.resolve();
    setSectionChart({ loading: true, error: null });
    return axios({
      method: "get",
      url: PROGRESS_BANTUAN_API + tahun,
      timeout: API_TIMEOUT,
      credentials: "include",
    })
      .then((response) => {
        if (response.status !== 200) {
          setSectionChart({
            loading: false,
            error: "Respons tidak valid untuk grafik bantuan",
          });
          return;
        }
        const data = response.data?.data ?? [];
        const aggregated = {};
        for (const row of data) {
          const key = String(row.bantuan || "").trim();
          if (!key) continue;
          if (!aggregated[key]) {
            aggregated[key] = {
              bantuan: key,
              totalPenerima: 0,
              desil1: 0,
              desil2: 0,
              totalUang: parseFloat(row.totalUang) || 0,
            };
          }
          aggregated[key].totalPenerima += parseInt(row.jumlahpenerima, 10) || 0;
          aggregated[key].desil1 += parseInt(row.totalDesil1, 10) || 0;
          aggregated[key].desil2 += parseInt(row.totalDesil2, 10) || 0;
        }
        const entries = Object.values(aggregated).sort((a, b) =>
          (a.bantuan || "").localeCompare(b.bantuan || "")
        );
        setChartBantuanDesil({
          labels: entries.map((e) => e.bantuan),
          totalPenerima: entries.map((e) => e.totalPenerima),
          desil1: entries.map((e) => e.desil1),
          desil2: entries.map((e) => e.desil2),
          totalUang: entries.map((e) => e.totalUang || 0),
        });
        setSectionChart({ loading: false, error: null });
      })
      .catch((error) => {
        setChartBantuanDesil({
          labels: [],
          totalPenerima: [],
          desil1: [],
          desil2: [],
          totalUang: [],
        });
        setSectionChart({
          loading: false,
          error: getAxiosErrorMessage(error),
        });
      });
  };

  const toSmallCaps = (text) => {
    return text.toLowerCase().replace(/(?:^|\s)\S/g, (char) => {
      return char.toUpperCase();
    });
  };

  const fetchProgresDinas = (tahun) => {
    if (!tahun) return Promise.resolve();
    setSectionDinas({ loading: true, error: null });
    const bearer = accessToken || localStorage.getItem("token") || "";
    return axios({
      method: "get",
      url: PROGRESS_DINAS_API + tahun,
      timeout: API_TIMEOUT,
      credentials: "include",
      headers: bearer ? { Authorization: `Bearer ${bearer}` } : {},
    })
      .then((response) => {
        if (response.status !== 200) {
          setSectionDinas({
            loading: false,
            error: "Respons tidak valid untuk progres dinas",
          });
          return;
        }
        const data = response.data?.data ?? [];
        const groupedData = data.reduce((result, item) => {
          const { dinas, jmlPenerima, jumlahmiskinekstrim, jumlahpenerima } =
            item;
          if (!result[dinas]) {
            result[dinas] = {
              dinas,
              totalPenerima: 0,
              totalME: 0,
              penerima: 0,
            };
          }
          result[dinas].totalPenerima += parseInt(jmlPenerima, 10) || 0;
          result[dinas].totalME += jumlahmiskinekstrim || 0;
          result[dinas].penerima += jumlahpenerima || 0;
          return result;
        }, {});
        setProgresDinas(Object.values(groupedData));
        setSectionDinas({ loading: false, error: null });
      })
      .catch((error) => {
        setProgresDinas([]);
        setSectionDinas({
          loading: false,
          error: getAxiosErrorMessage(error),
        });
      });
  };

  const fetchProgresKecamatan = (tahun) => {
    if (!tahun) return Promise.resolve();
    setSectionKecamatan({ loading: true, error: null });
    return axios({
      method: "get",
      url: KECAMATAN_BANTUAN_TAHUN + tahun,
      timeout: API_TIMEOUT,
      credentials: "include",
    })
      .then((response) => {
        if (response.status !== 200) {
          setSectionKecamatan({
            loading: false,
            error: "Respons tidak valid untuk data kecamatan",
          });
          return;
        }
        const data = response.data?.data ?? [];
        setProgresKecamatan(data);
        setSectionKecamatan({ loading: false, error: null });
      })
      .catch((error) => {
        console.error("fetchProgresKecamatan:", error?.message || error);
        setProgresKecamatan([]);
        setSectionKecamatan({
          loading: false,
          error: getAxiosErrorMessage(error),
        });
      });
  };

  return (
    <div>
      <div className={s.summaryRekapanCard}>
        <div className={s.summaryRekapanHeader}>
          <h4 className={s.summaryRekapanTitle}>
            Rekapan Bantuan Sosial — Tahun {simpleDropdownValue}
          </h4>
          {sectionChart.loading && (
            <Spinner size="sm" color="primary" className={s.summarySpinner} />
          )}
        </div>
        {sectionChart.error && (
          <Alert color="danger" className="py-2 px-3 mb-2 small">
            Grafik bantuan / ringkasan tahun: {sectionChart.error}
          </Alert>
        )}
        <div className={s.summaryRekapanGrid}>
          <div className={`${s.summaryItem} ${s.summaryItemRed}`}>
            <span className={s.summaryIconWrap}>
              <i className="eva eva-layers-outline eva-lg" />
            </span>
            <div className={s.summaryContent}>
              <span className={s.summaryLabel}>Jumlah Bantuan</span>
              <span className={s.summaryValue}>
                {sectionChart.loading ? "..." : summaryRekapan.jumlahBantuan}
              </span>
            </div>
          </div>
          <div className={`${s.summaryItem} ${s.summaryItemBlue}`}>
            <span className={s.summaryIconWrap}>
              <i className="eva eva-credit-card-outline eva-lg" />
            </span>
            <div className={s.summaryContent}>
              <span className={s.summaryLabel}>Total Dana Bantuan</span>
              <span className={s.summaryValue}>
                {sectionChart.loading
                  ? "..."
                  : formatRupiah(summaryRekapan.totalDana)}
              </span>
            </div>
          </div>
          <div className={`${s.summaryItem} ${s.summaryItemGreen}`}>
            <span className={s.summaryIconWrap}>
              <i className="eva eva-people-outline eva-lg" />
            </span>
            <div className={s.summaryContent}>
              <span className={s.summaryLabel}>Total Penerima</span>
              <span className={s.summaryValue}>
                {sectionChart.loading
                  ? "..."
                  : summaryRekapan.totalPenerima.toLocaleString("id-ID")}
              </span>
            </div>
          </div>
          <div className={`${s.summaryItem} ${s.summaryItemRed}`}>
            <span className={s.summaryIconWrap}>
              <i className="eva eva-heart-outline eva-lg" />
            </span>
            <div className={s.summaryContent}>
              <span className={s.summaryLabel}>Penerima Desil 1 + 2</span>
              <span className={s.summaryValue}>
                {sectionChart.loading
                  ? "..."
                  : summaryRekapan.totalDesil12.toLocaleString("id-ID")}
              </span>
            </div>
          </div>
          <div className={`${s.summaryItem} ${s.summaryItemHighlight} ${s.summaryItemBlue}`}>
            <span className={s.summaryIconWrap}>
              <i className="eva eva-trending-up-outline eva-lg" />
            </span>
            <div className={s.summaryContent}>
              <span className={s.summaryLabel}>Persentase Desil 1+2</span>
              <span className={s.summaryValue}>
                {sectionChart.loading ? "..." : summaryRekapan.persentaseDesil12}%
              </span>
            </div>
          </div>
        </div>
      </div>

      <Row>
        <Col className="pr-grid-col" xs={12} lg={8}>
          <Row className="gutter mb-4">
            <Col xs={12}>
              <Widget
                style={{ padding: 20 }}
                className={`${s.sectionBlock} ${s.chartPenerimaDesil} ${sectionChart.loading ? s.sectionBlockLoading : ""}`}
              >
                {sectionChart.loading && (
                  <div className={s.sectionOverlay}>
                    <Spinner color="primary" />
                    <span className={s.sectionLoadingText}>
                      Memuat grafik bantuan…
                    </span>
                  </div>
                )}
                <div className="headline-2 mb-2">
                  Penerima Bantuan vs Desil 1 dan 2
                </div>
                {sectionChart.error && (
                  <div className={s.sectionError}>{sectionChart.error}</div>
                )}
                <ApexCharts
                  series={apexCharts.lineColumn.series}
                  options={apexCharts.lineColumn.options}
                />
              </Widget>
            </Col>
          </Row>
          <Row className="gutter">
            <Col xs={12}>
              <Widget
                style={{ padding: 20 }}
                className={`${s.sectionBlock} ${sectionLimaTahun.loading ? s.sectionBlockLoading : ""}`}
              >
                {sectionLimaTahun.loading && (
                  <div className={s.sectionOverlay}>
                    <Spinner color="primary" />
                    <span className={s.sectionLoadingText}>
                      Memuat tren 5 tahun…
                    </span>
                  </div>
                )}
                <div className="headline-2 mb-2">
                  Penerima Bantuan 5 Tahun Terakhir
                </div>
                {sectionLimaTahun.error && (
                  <div className={s.sectionError}>{sectionLimaTahun.error}</div>
                )}
                <ApexCharts
                  series={apexCharts.lineArea.series}
                  options={apexCharts.lineArea.options}
                  type="area"
                />
              </Widget>
            </Col>
          </Row>
          <Row className="gutter">
            <Col xs={12}>
              <Widget
                className={`${s.sectionBlock} ${sectionPie.loading ? s.sectionBlockLoading : ""}`}
              >
                {sectionPie.loading && (
                  <div className={s.sectionOverlay}>
                    <Spinner color="primary" />
                    <span className={s.sectionLoadingText}>
                      Memuat akumulasi desil…
                    </span>
                  </div>
                )}
                {sectionPie.error && (
                  <div className={s.sectionError}>
                    Akumulasi desil: {sectionPie.error}
                  </div>
                )}
                <HighchartsReact
                  highcharts={Highcharts}
                  options={highcharts.variableRadiusPie}
                />
              </Widget>
            </Col>
          </Row>
        </Col>
        <Col className={`mt-4 mt-lg-0 pl-grid-col ${s.colRightStretch}`} xs={12} lg={4}>
          <Widget className={`widget-p-lg ${s.rightColumnWidget}`}>
            <div className={s.rightWidgetContent}>
            <div className={`${s.bansosBlock} ${sectionDinas.loading ? s.sectionBlockLoading : ""}`}>
              {sectionDinas.loading && (
                <div className={`${s.sectionOverlay} ${s.sectionOverlayCompact}`}>
                  <div className="d-flex align-items-center gap-2">
                    <Spinner size="sm" color="primary" />
                    <span className={s.sectionLoadingText}>Memuat progres per dinas…</span>
                  </div>
                </div>
              )}
            <div className={s.goalsTitle}>
              <p className="headline-3">Bansos</p>
              <UncontrolledButtonDropdown>
                <DropdownToggle caret color="primary">
                  {simpleDropdownValue}
                </DropdownToggle>

                <DropdownMenu>
                  {listTahun &&
                    listTahun.map((item) => (
                      <DropdownItem
                        key={item.tahun}
                        onClick={changeSelectDropdownSimple}
                      >
                        {item.tahun}
                      </DropdownItem>
                    ))}
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
            {sectionDinas.error && (
              <div className={s.sectionError}>Progres dinas: {sectionDinas.error}</div>
            )}
            {progresDinas && progresDinas.length > 0
              ? progresDinas.map((item) => (
                <div className="d-flex flex-column mt-3" key={item.dinas}>
                  <div className={s.activity}>
                    <p className="body-2">{toSmallCaps(item.dinas)} </p>
                    <p className="body-2">
                      {item.penerima}
                      <span className="body-3 muted">
                        /{item.totalPenerima}
                      </span>
                    </p>
                  </div>
                  <Progress
                    color={
                      (item.penerima / item.totalPenerima) * 100 < 50
                        ? "danger"
                        : (item.penerima / item.totalPenerima) * 100 >= 50 &&
                          (item.penerima / item.totalPenerima) * 100 <= 90
                        ? "warning"
                        : "success"
                    }
                    className="progress-xs"
                    value={(item.penerima / item.totalPenerima) * 100}
                  />
                </div>
              ))
              : !sectionDinas.loading && !sectionDinas.error ? (
                <p className="body-3 muted mt-2">Belum ada data dinas</p>
              ) : null}
            </div>

            <div className={`${s.kecamatanSection} ${s.kecamatanBlock} ${sectionKecamatan.loading ? s.sectionBlockLoading : ""}`}>
            <p className="headline-3 mt-4">Kecamatan</p>
            {sectionKecamatan.loading && (
              <div className="d-flex align-items-center gap-2 py-2">
                <Spinner size="sm" color="primary" />
                <span className={s.sectionLoadingText}>Memuat data kecamatan…</span>
              </div>
            )}
            {sectionKecamatan.error && (
              <div className={s.sectionError}>Kecamatan: {sectionKecamatan.error}</div>
            )}
            <div className={s.kecamatanCardWrap}>
              {!sectionKecamatan.loading && progresKecamatan.length > 0 ? (
                progresKecamatan.map((kec) => {
                  const total = kec.jumlah_penerima || 0;
                  const desil12 = kec.total_desil12 || 0;
                  const pctDesil =
                    total > 0 ? ((desil12 / total) * 100).toFixed(1) : "0";
                  return (
                    <div
                      key={kec.kecamatan}
                      className={s.kecamatanCardItem}
                    >
                      <div className={s.kecamatanCardHeader}>
                        <span className={s.kecamatanCardName}>
                          {toSmallCaps(kec.kecamatan)}
                        </span>
                        <span className={s.kecamatanCardPct}>
                          {pctDesil}% D1+2
                        </span>
                      </div>
                      <div className={s.kecamatanCardStats}>
                        <span>
                          {total.toLocaleString("id-ID")} org
                        </span>
                        <span>·</span>
                        <span>{formatRupiah(kec.total_uang)}</span>
                        <span>·</span>
                        <span className={s.kecamatanCardDesil}>
                          {desil12.toLocaleString("id-ID")} Desil 1 & 2
                        </span>
                      </div>
                      <Progress
                        color={
                          Number(pctDesil) >= 70
                            ? "success"
                            : Number(pctDesil) >= 40
                            ? "warning"
                            : "info"
                        }
                        className="progress-xs mt-1"
                        value={Math.min(Number(pctDesil), 100)}
                      />
                    </div>
                  );
                })
              ) : !sectionKecamatan.loading && !sectionKecamatan.error ? (
                <p className="body-3 muted">Belum ada data kecamatan</p>
              ) : null}
            </div>
            </div>
            </div>
          </Widget>
        </Col>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Col className="pr-grid-col" xs={12} lg={12}>
          <Widget style={{ padding: 20 }}>
            <Map tahun={simpleDropdownValue} />
          </Widget>
        </Col>
      </Row>
    </div>
  );
}
